import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SupportTicket } from '../../models/support-ticket/support-ticket.interface';

@Injectable({ providedIn: 'root' })
export class SupportTicketService {
	private readonly relativeUrl = 'participants';

	constructor(private readonly http: HttpClient) {}

	getTicketDetails(ticketId: string, participantId: string, activeProduct: string): Observable<SupportTicket> {
		return this.http.get<SupportTicket>(
			`${this.relativeUrl}/${participantId}/vhd/tickets/${ticketId}?activeProduct=${activeProduct}`
		);
	}

	retrieveContentDetails(
		ticketId: string,
		participantId: string,
		notesId: string,
		annotationId: string
	): Observable<HttpResponse<Blob>> {
		return this.http.get(
			`${this.relativeUrl}/${participantId}/vhd/tickets/${ticketId}/notes/${notesId}/${annotationId}`,
			{
				observe: 'response',
				responseType: 'blob'
			}
		);
	}
}
